import { HeartPulse, Plus } from 'lucide-react';
import { tr } from '@/lib/i18n-core';
import { useAuth } from '@/lib/auth';
import { dateTime } from '@/lib/utils';
import { DataTable } from '@/components/ui/layout';
import { Button } from '@/components/ui/primitives';
import { ShellSectionHeading } from '@/components/clinical-shell/ShellPanel';
import { admissionIsOpen, type Admission } from '../../admission/types';

export function VitalsChartSection({ admission, onRecord }: { admission: Admission; onRecord: () => void }) {
  const { can } = useAuth();
  const current = admissionIsOpen(admission);

  return (
    <>
      <ShellSectionHeading
        icon={HeartPulse}
        title={tr('ipd', 'vitals')}
        description={tr('ipd', 'ws_vitals_desc')}
        actions={
          current && can('vitals.write') ? (
            <Button size="sm" variant="outline" onClick={onRecord}>
              <Plus className="h-4 w-4" aria-hidden /> {tr('ipd', 'record_vitals')}
            </Button>
          ) : null
        }
      />
      <DataTable
        rows={admission.vitals}
        rowKey={(row) => row.id}
        empty={tr('ipd', 'no_vitals_recorded')}
        columns={[
          { header: tr('ipd', 'recorded'), cell: (row) => dateTime(row.recordedAt) },
          { header: tr('ipd', 'bp'), align: 'right', cell: (row) => (row.bpSystolic ? `${row.bpSystolic}/${row.bpDiastolic}` : '—') },
          { header: tr('ipd', 'pulse'), align: 'right', cell: (row) => row.pulse ?? '—' },
          { header: tr('ipd', 'temp'), align: 'right', cell: (row) => (row.temperatureC ? `${row.temperatureC} °C` : '—') },
          { header: tr('ipd', 'spo'), align: 'right', cell: (row) => (row.spo2 ? `${row.spo2}%` : '—') },
        ]}
      />
    </>
  );
}
